// extracted by mini-css-extract-plugin
export var actionButton = "_pj-0";
export var actionMenuContainer = "_pj-i";
export var bubble = "_pj-2";
export var bubbleActionMenu = "_pj-j";
export var bubbleContext = "_pj-6";
export var bubbleItems = "_pj-7";
export var customer = "_pj-3";
export var divider = "_pj-8";
export var fileList = "_pj-9";
export var hiddenComment = "_pj-o";
export var infoAbove = "_pj-a";
export var internal = "_pj-4";
export var lightActionButton = "_pj-1";
export var link = "_pj-b";
export var merchant = "_pj-5";
export var message = "_pj-c";
export var profilePicture = "_pj-e";
export var quillToolbarContainer = "_pj-f";
export var senderDate = "_pj-g";
export var senderDateCustomer = "_pj-h";
export var senderName = "_pj-d";
export var time = "_pj-k";
export var uploadedImage = "_pj-l";
export var username = "_pj-m";
export var xsmall = "_pj-n";